// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__-e9c1","containerItemsCenter":"Skeleton_containerItemsCenter__1mYUb"};